import { useState, useEffect } from 'react';
import { Input, Button, Typography, Divider, Space } from 'antd';
import { UserOutlined, PhoneOutlined } from '@ant-design/icons';

import { toast } from 'react-toastify';
import { Method_POST_WHATSAPP } from '../../../../../../service/api';

const { Text, Paragraph } = Typography;

const ModalReport = ({ info, setIsModalReportLeads, atualizarOS }) => { // ESSE setIsModalReportLeads VAI SERVIR PARA ABRIR O MODAL


    const [body, setBody] = useState({
        nome: info.nomeCliente || '',
        email: info.email,
        telefone: info.telefone || '',
        origem: 'portal-mco',
        mensagem: ''
    });

    const [isSend, setIsSend] = useState(false);
    const [sending, setSending] = useState(false);

    // sincroniza quando trocar o profileSelected
    useEffect(() => {
        setBody(prev => ({
            ...prev,
            nome: info.nomeCliente || '',
            telefone: info.telefone || ''
        }));
    }, []);

    useEffect(() => {
        setIsSend((body.mensagem?.trim()?.length || 0) > 1);
    }, [body.mensagem]);

    const handleClose = () => setIsModalReportLeads(false);

    const handleSend = async () => {
        try {
            setSending(true);
            const url = "/lamp/enviar";

            let response = await Method_POST_WHATSAPP(url, body);

            console.log("teste", response);


            if (response) {
                toast.success("Reporte enviado com sucesso!");
                atualizarOS();
            }

            handleClose();
        }catch(error){
             console.error("Erro na API da LAMP!", error);
                toast.error("Erro ao enviar reporte!");
        } finally {
            setSending(false);
        }
    };

    const formatarTelefone = (numero) => {
        let digits = numero.replace(/\D/g, '');

        // Remove +55 se vier
        if (digits.startsWith('55') && digits.length > 11) {
            digits = digits.slice(2);
        }

        if (digits.length === 11) {
            // Celular: (99) 99999-9999
            return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }

        if (digits.length === 10) {
            // Fixo: (99) 9999-9999
            return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        }

        // fallback para internacional ou formatos diferentes
        return numero;
    }

    return (
        <>
            {/* CONTENT */}
            <div style={{ padding: '0 16px 16px', overflowY: 'auto' }}>
                <Space direction="vertical" size={8} style={{ width: '100%' }}>
                    <Space size={8} align="start" style={{ width: '100%' }}>
                        <UserOutlined />
                        <Paragraph style={{ margin: 0 }} ellipsis={{ rows: 1, tooltip: body.nome }}>
                            <Text strong>{body.nome || '—'}</Text>
                        </Paragraph>
                    </Space>

                    <Space size={8} align="start" style={{ width: '100%' }}>
                        <PhoneOutlined />
                        <Text type="secondary">
                            {body.telefone
                                ? formatarTelefone(body.telefone)
                                : '—'}
                        </Text>
                    </Space>

                    <Divider style={{ margin: '8px 0' }} />

                    <Input.TextArea
                        rows={5}
                        placeholder="Descreva o motivo do reporte (ex.: spam, fora de perfil...)"
                        value={body.mensagem}
                        onChange={(e) => setBody(prev => ({ ...prev, mensagem: e.target.value }))}
                        allowClear
                        showCount
                        maxLength={600}
                        autoSize={{ minRows: 5, maxRows: 8 }}
                    />
                </Space>
            </div>

            {/* FOOTER FIXO */}
            <div
                style={{
                    marginTop: 'auto',
                    borderTop: '1px solid #f0f0f0',
                    padding: '12px 16px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 8,
                    background: '#fff'
                }}
            >

                {isSend && (

                    <Button
                        onClick={handleSend}
                        disabled={!isSend || sending}
                        loading={sending ? 1 : 0}
                    >
                        Enviar
                    </Button>

                )}
            </div>
        </>
    );
};

export default ModalReport;
